<template>
    <NxSelect
    :value="localValue"
    :options="listOptions"
    :labelText="`Risco ${riskType}:`"
    :id="`selectRisco${riskType}`"
    placeholder="Selecione o(s) Risco(s)"
    :multiple="true"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'
import riskTypes from '@/enums/enumRiskTypes.js'

const BacenRisks = ['AA', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'HH', 'NC']
const SicoobRisks = ['R1', 'R2', 'R3', 'R4', 'R5', 'R6', 'R7', 'R8', 'R9', 'R10', 'R11', 'R12', 'R13', 'R14', 'R15', 'R16', 'R17', 'R18', 'R19', 'R20', 'NAO SE APLICA']

export default {
  name: 'NxSelectRisco',
  mixins: [ useReactiveModelMixin('value') ],
  props: {
    riskType: {
      type: String,
      required: true,
      default: null
    }
  },
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onMapRisks()
  },
  methods: {
    onMapRisks () {
      let risks

      if (this.riskType === riskTypes[0]) risks = BacenRisks
      else if (this.riskType === riskTypes[1]) risks = SicoobRisks

      risks.forEach((el) =>
        this.listOptions.push({'value': el, 'text': el})
      )
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectRisco.vue